module.exports = __webpack_public_path__ + "img/76b0603ac97984ba8aae113b0599e0f8.png";